module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-Influencer-Video-2.6f5b1531.webp";